<script>
  export let params;
  export let currentRoute;
</script>

<section id="about" class="section">
    <div class="container px-lg-4 px-xl-5">
        <div class="row">
            <div class="col-lg-10 mx-auto text-center">
                <h2 class="text-center font-weight-600 line-height-4 mb-4 mx-lg-5">Términos y Condiciones</h2>
                <h4 class="text-left mb-4">DENUNCIAS:</h4>
                <p class="lead text-justify">Nuestra plataforma garantiza el completo anonimato de quienes efectúen denuncias.</p>
                <p class="lead text-justify">El canal de denuncias anónimas es para denunciar cualquier tipo de delito del cual usted tenga conocimiento.</p>
                <h4 class="text-left mb-4 mt-4"> ASISTENCIA LEGAL:</h4>
                <p class="lead text-justify">La asistencia legal gratuita es solo para materias referidas a temas penales y de familia, por ello las consultas en relación a materias legales distintas a las indicadas, serán respondidas con orientaciones de carácter muy general.</p>
                <p class="lead text-justify">La información que sea entregada a nuestros abogados por esta vía, será tratadas con absoluta confidencialidad.</p>
                <p class="lead text-justify">La asistencia legal gratuita es una orientación legal que en ningún caso implica una representación legal para los solicitantes, quienes podrán cotizar esta.</p>
            </div>
        </div>

    </div>
</section>